import { registerLocaleData } from '@angular/common';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import localeFr from '@angular/common/locales/fr';
import { appRoutes } from './app.routes';
import { commonsProviders } from './config/commons.config';
import { initProvider } from './config/app-init.config';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideRouter(appRoutes),
    initProvider,
    commonsProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
};
